module.exports = __webpack_public_path__ + "img/chunlin.c34804d7.png";